import type { SpreadsheetField } from '../../../hooks';

/** Column mapping used by both the create-import and the append-to-an-existing-list flows. */
export const emailListImportFields: SpreadsheetField[] = [
    {
        name: 'emailAddress',
        labelField: 'Email',
        required: true,
        extraAliases: ['email', 'e-mail', 'emailaddress', 'e-mailaddress', 'emailadres', 'e-mailadres', 'email address', 'e-mail address']
    },
    { name: 'firstName', labelField: 'FirstName' },
    { name: 'lastName', labelField: 'LastName' },
    { name: 'nickname', labelField: 'Nickname' },
    { name: 'companyName', labelField: 'CompanyName' },
    { name: 'countryCode', labelField: 'Country' }
];
